import React from 'react'
import { withIcon } from '../../withIcon'

interface RefreshArrowsIconProps {
  size?: string
  color?: string
}

/**
 * Two-arc refresh / retry icon (opposing curved arrows).
 *
 * Per Figma node 3663-104334 ("Try Again" button on the Create a Vibe Line
 * modal step 4 footer). Path copied verbatim from the Figma export.
 *
 * Distinct from the single-arrow `Refresh` icon already in the codebase —
 * the design specifies this two-arrow visual.
 */
function RefreshArrowsIcon (props: RefreshArrowsIconProps) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 12.8403C19.7371 15.2962 18.3376 17.5977 16.0219 18.9271C12.1745 21.1358 7.25479 19.825 5.03348 15.9994L4.64266 15.1373M8.43937 15.9994L4.64266 15.1373L4 18.9271M4 11.1597C4.2629 8.70376 5.66237 6.40234 7.97811 5.07293C11.8255 2.86421 16.7452 4.17496 18.9665 8.00058L19.3579 8.86274M20 5.07293L19.3579 8.86274L15.6239 8.00058"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default withIcon(RefreshArrowsIcon)
